import React, { useContext } from 'react'
import classnames from 'classnames'
import { PaymentFormContext } from './GpiWrapper'

// Allow any component to render the GPI payment form fields
// these fields are styled via:
// (1) `gpi-wrapper` class in _forms.scss
// (2) the `style` object passed to the form configuration in GpiWrapper
export default function GpiSubmit() {
  // PaymentFormContext comes with a several keys:
  // (1) `formErrors`: an object with error messages for any invalid payment fields
  // (2) `hasBeenSubmitted`: a boolean indicating whether the form has been submitted by the user
  // (3) `arePaymentFieldsLoading`: a boolean indicating whether the payment form JavaScript is loading
  // (4) `isDisabled`:a boolean indicating whether the GPI payments experience is currently disabled to the user
  const { arePaymentFieldsLoading, isDisabled } = useContext(PaymentFormContext)

  return (
    <div
      className={classnames('gpi-wrapper', {
        'gpi-wrapper--disabled': arePaymentFieldsLoading || isDisabled,
      })}
    >
      {/* GPI JavaScript library uses this anchor to render the Submit button that triggers tokenization */}
      <div id="submit" />
    </div>
  )
}

export function gpiSubmitStyles({ isDisabled }) {
  return {
    button: {
      'background-color': '#FA9806', // Orange
      color: 'white',
      'font-size': '18px',
      'font-weight': 'normal',
      'border-radius': '0px', // Rectangular
      'text-align': 'center',
      width: '100%', // Full width
      border: '0',
      'text-transform': 'uppercase', // Match original
      padding: '15px 20px',
      'box-shadow': 'none',
      'text-decoration': 'none',
      opacity: isDisabled ? '0.6' : '1.0',
      'pointer-events': isDisabled ? 'none' : 'auto',
      cursor: 'pointer',
    },
    'button:hover': {
      cursor: 'pointer',
      'background-color': '#FA8A06', // Darker orange on hover
    },
  }
}
